import React from "react"
import styles from './Hero.module.scss'
import eventBus from "../utils/EventBus";
import Contact from "./Contact";
import photo from '../UI/images/julian-capilla.jpg'

const CV_URL = '/julian-capilla-cv.pdf'
const LINKEDIN_URL = 'https://www.linkedin.com/in/julian-capilla-b2a24359/'

export default function Hero() {
    function handleContactClick() {
        eventBus.publish('modal', {
            title: "Contact",
            content: <Contact/>
        })
    }

    return (
        <div className={styles.hero}>
            <img className={styles.photo} src={photo} alt="Julian Capilla" width="168" height="168"/>
            <div className={styles.text}>
                <h1 className={styles.name}>Julian Capilla</h1>
                <p className={styles.role}>Senior Software Engineer &amp; Solution Architect</p>
                <p className={styles.pitch}>
                    I'm a software engineer with <b>10+ years</b> of experience building enterprise software. I've worked across the full stack, end to end,
                    from turning a rough idea into a working proof of concept, to building the real, production-grade enterprise system.
                </p>
                <div className={styles.ctaRow}>
                    <button className={styles.primaryButton} onClick={handleContactClick}>
                        Contact
                    </button>
                    <a className={styles.secondaryButton} href={CV_URL} target="_blank" rel="noopener noreferrer">
                        View my CV
                    </a>
                    <a className={styles.secondaryButton} href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
                        LinkedIn
                    </a>
                </div>
            </div>
        </div>
    )
}
